import { render, staticRenderFns } from "./StaffAutoComplete.vue?vue&type=template&id=2d3df31a&"
import script from "./StaffAutoComplete.vue?vue&type=script&lang=js&"
export * from "./StaffAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports